import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=5f0da59e&scoped=true"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=5f0da59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0da59e",
  null
  
)

export default component.exports